"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const RowItem = ({ label, children, size, description }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: `px-1`, children: [label && ((0, jsx_runtime_1.jsx)("div", { className: "small", children: label })), (0, jsx_runtime_1.jsx)("div", { className: "fw-bold text-truncate", children: children !== "" && children !== null && children !== undefined ? children : '—' }), description && (0, jsx_runtime_1.jsx)("div", { className: "small", children: description })] }));
};
exports.RowItem = RowItem;
